import { Helmet } from "react-helmet";
import DashboardLayout from "@/components/layouts/DashboardLayout";

const Messages = () => {
  return (
    <DashboardLayout>
      <Helmet>
        <title>Messages - Numberz Insight</title>
        <meta name="description" content="View and manage your messages and notifications." />
      </Helmet>

      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-semibold mb-6">Messages</h1>
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
          <p className="text-gray-600 dark:text-gray-300">Messaging features coming soon.</p>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Messages;